import FaceRetouchingNaturalOutlinedIcon from '@mui/icons-material/FaceRetouchingNaturalOutlined';

/**
 * Grau de acne: classificação brasileira da acne vulgar pela lesão que
 * predomina, do grau I (comedônica) ao V (fulminante).
 * Referência clínica: Sociedade Brasileira de Pediatria (Departamento de
 * Adolescência) e PCDT da acne do Ministério da Saúde (graus I a IV).
 * Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/acne_grade.php.
 */
const acneGrade = {
  key: 'acne_grade',
  name: 'Grau de acne',
  description: 'Gravidade da acne pela lesão que predomina, do I ao V',
  details: 'Classifica a acne pelo tipo de lesão que predomina, do grau I (só cravos, sem inflamação) ao V (forma fulminante, rara e com sintomas gerais). Ajuda a escolher o tratamento, decidir quando encaminhar ao dermatologista e acompanhar a resposta ao longo das sessões. Um clique marca o grau do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: FaceRetouchingNaturalOutlinedIcon,
  accent: 'pink',
  options: [
    { value: 'I', label: 'Grau I', caption: 'Comedônica', image: 'acne-grau-1.png', help: 'Cravos abertos e fechados (comedões), sem lesões inflamadas.' },
    { value: 'II', label: 'Grau II', caption: 'Papulopustulosa', image: 'acne-grau-2.png', help: 'Cravos com pápulas avermelhadas e pústulas (espinhas com pus).' },
    { value: 'III', label: 'Grau III', caption: 'Nódulo-cística', image: 'acne-grau-3.png', help: 'Além de pápulas e pústulas, nódulos e cistos profundos e doloridos.' },
    { value: 'IV', label: 'Grau IV', caption: 'Conglobata', image: 'acne-grau-4.png', help: 'Nódulos grandes que se unem, com abscessos, trajetos sob a pele e cicatrizes.' },
    { value: 'V', label: 'Grau V', caption: 'Fulminante', image: 'acne-grau-5.png', help: 'Forma rara e súbita, com lesões que ulceram e sintomas como febre e dor nas juntas. Pede avaliação médica urgente.' },
  ],
};

export default acneGrade;
